import { Injectable } from '@angular/core';
import { StoreService } from './store.service';

@Injectable({ providedIn: 'root' })
export class NgrxLocalStorageService implements StoreService {
    private saveTimeout: any; // To hold the reference of the timeout
    private readonly SAVE_DELAY = 1000; // 10 seconds in milliseconds

    constructor() {}

    setSavedState(state: any, localStorageKey: string) {
        // Clear the previous timeout if it exists
        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
        }

        // Set a new timeout to save the state after 10 seconds
        this.saveTimeout = setTimeout(() => {
            //console.log('NgrxLocalStorageService save', state);
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        }, this.SAVE_DELAY);
    }

    getSavedState(localStorageKey: string): any {
        //console.log('NgrxLocalStorageService get');
        return JSON.parse(localStorage.getItem(localStorageKey));
    }
}
